
import { Inject, Injectable } from '@angular/core';

import { KsefCheckDocumentStatusCommand, KsefCheckDocumentStatusCommandBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';

@CommandHandlerFor(KsefCheckDocumentStatusCommand)
@Injectable({ providedIn: 'root'})
export class KsefCheckDocumentStatusCommandHandler {
    private commandHandler: KsefCheckDocumentStatusCommandBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new KsefCheckDocumentStatusCommandBase(http);
    }

    public async handleAsync(query: KsefCheckDocumentStatusCommand): Promise<any> {
        await this.commandHandler.handleAsync(query);
    }
}
